import React from "react";

const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const getWeekdayName = (weekday: number) =>
  WEEKDAYS[weekday - 1] ?? `Day ${weekday}`;

interface OpeningTimes {
  regular_hours?: {
    weekday: number;
    period_begin: string;
    period_end: string;
  }[];
}

export default function OpeningHours({
  openingTimes,
}: {
  openingTimes: OpeningTimes;
}) {
  return (
    <div>
      {openingTimes?.regular_hours?.length ? (
        <div className="flex flex-column gap-2">
          {openingTimes.regular_hours.map((time, index) => (
            <div
              key={index}
              className="flex justify-content-between align-items-center py-2 px-3 border-round"
              style={{ background: "var(--surface-ground)" }}
            >
              <span className="font-medium">{getWeekdayName(time.weekday)}</span>
              <span className="text-color-secondary">
                {time.period_begin} – {time.period_end}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-color-secondary">Opening hours not available.</p>
      )}

    </div>
  );
}
